import React, { useEffect, useMemo, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Modal, Button } from "antd";
import Papa from 'papaparse'
import ReactTable from 'react-table';
import moment from "moment";
import { setPageTitle } from "../../../Dashboard/DashboardActions";
import {
  Row,
  Col,
  Card,
  Checkbox,
  Input,
  Select,
  Table,
  Tooltip,
  Typography,
  Radio,
  Tag,
  Collapse,
} from 'antd';
import AppLayout from "../../../Dashboard/components/AppLayoutV2/AppLayout";
import { getAllCasesRequest, updateCaseRequest } from "../../CaseApiActions";
import UtilHelper from "../../../../utils/UtilHelper";

import { connect } from 'react-redux';
import DeleteCase from "../DeleteCaseV2/DeleteCase";
import CaseDetailsModal from "../ViewCaseV2/ViewCase";
import SymptomsQueryTags from "../GenaScreen/SymptomsQueryTags/SymptomsQueryTags";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import DataGrid from '../../../../utils/components/DataGrid/DataGrid'
import CustomIcon from "../../../../utils/components/CustomIcon/CustomIcon";
import Notification from "../../../../utils/Notification";

const { Title } = Typography
const notification = new Notification()

const CaseTableComponent = (props) => {
  const dataGridRef = useRef(null)
  const { ownOnly = true, getAllCases } = props
  const history = useHistory()
  const [filter, setFilter] = useState('all') // all | testRequested
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [cases, setCases] = useState([])
  const [showCaseDetailsModal, setShowCaseDetailsModal] = useState(false)
  const [selectedCase, setSelectedCase] = useState(null)

  const columnDefs = useMemo(() => {
    return [
      ...(!ownOnly
        ? [{
          headerName: 'User',
          maxWidth: 200,
          valueGetter: (params) => {
            const first = params.data.User.firstName || '';
            const last = params.data.User.lastName || '';
            return `${first} ${last}`.trim();
          }
        }]
        : []),
      {
        headerName: 'Case Number',
        field: 'nickName',
        maxWidth: 200,
        cellRendererFramework: (params) => {
          return <Tooltip placement="topLeft" title={params.data.nickName}>{params.data.nickName}</Tooltip>
        }
      },
      {
        headerName: 'Symptoms',
        autoHeight: true,
        valueGetter: (params) => {
          const sortedResult = params.data.CaseVersions?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          const latestCaseVersion = sortedResult[0]
          return latestCaseVersion?.SearchHistory?.query
        },
        cellRendererFramework: (params) => {
          const sortedResult = params.data.CaseVersions?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          const latestCaseVersion = sortedResult[0]
          if (latestCaseVersion?.SearchHistory) {
            return <SymptomsQueryTags node={latestCaseVersion?.SearchHistory?.queryJSON} />;
          }
          return null;
        }
      },
      {
        headerName: 'Updated',
        field: 'updatedAt',
        maxWidth: 150,
        sort: 'desc',
        getQuickFilterText: (params) => {
          return moment.utc(params.data.updatedAt).local().format("DD/MM/YYYY")
        },
        cellRendererFramework: (params) => {
          return moment.utc(params.data.updatedAt).local().format("DD/MM/YYYY")
        }
      },
      {
        headerName: 'Created',
        field: 'createdAt',
        maxWidth: 150,
        getQuickFilterText: (params) => {
          return moment.utc(params.data.createdAt).local().format("DD/MM/YYYY")
        },
        cellRendererFramework: (params) => {
          return moment.utc(params.data.createdAt).local().format("DD/MM/YYYY")
        }
      },
      {
        headerName: '',
        maxWidth: 75,
        sortable: false,
        cellRendererFramework: (params) => {
          const sortedResult = params.data.CaseVersions?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          const latestCaseVersion = sortedResult[0]
          return (
            <Tooltip title={'Resume search'}>
              <CustomIcon
                name="Search"
                width={24}
                height={24}
                // style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  history.push(`/search?searchRecordId=${latestCaseVersion?.SearchHistory?.id}`);
                }}
              />
              {/* <SearchOutlined
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  history.push(`/search?searchRecordId=${latestCaseVersion?.SearchHistory?.id}`);
                }}
              /> */}
            </Tooltip>
          );
        }
      }
    ];

  }, [ownOnly])

  useEffect(() => {
    setLoading(true)
    getAllCases(null, { ownOnly, testRequestedOnly: filter === 'testRequested', limit: 100000 }).then()
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }, [getAllCases, ownOnly, filter])

  const handleRowClick = (caseObj) => {
    setSelectedCase(caseObj)
    setShowCaseDetailsModal(true)
  }

  const exportCSV = () => {
    dataGridRef.current.api.exportDataAsCsv({
      fileName: `cases-${moment().format('DD-MM-YYYY')}.csv`,
    });
    notification.show('info', 'Data Exported');
    // const filename = 'cases.csv'
    // const csv = Papa.unparse(props.cases); // Convert JSON to CSV
    // const blob = new Blob([csv], { type: "text/csv" });
    // const url = URL.createObjectURL(blob);

    // const a = document.createElement("a");
    // a.href = url;
    // a.download = filename;
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
  };

  useEffect(() => {
    if (!dataGridRef?.current?.api) return
    const searchText = debouncedSearch.trim()
    dataGridRef.current.api.setQuickFilter(searchText);
  }, [dataGridRef, debouncedSearch])

  // Debounce effect on search
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 600);

    // Cancel timeout if search text changes before 600ms
    return () => clearTimeout(handler);
  }, [search]);

  return (
    <div className="flex-vertical" style={{ gap: '16px' }}>
      <div className="flex-horizontal" style={{ justifyContent: "space-between" }}>
        <Title level={2} style={{ margin: 0 }}>Cases</Title>
        <Button onClick={exportCSV}>Export<CustomIcon name="Download" /></Button>
      </div>
      <div className="flex-horizontal-gap-2">
        <Radio.Group style={{ minWidth: 'max-content'}} value={filter} onChange={(e) => setFilter(e.target.value)}>
          <Radio.Button value="all">All</Radio.Button>
          <Radio.Button value="testRequested">Test Requested</Radio.Button>
        </Radio.Group>
        <Input
          allowClear
          placeholder="Search"
          prefix={<CustomIcon name="Search" />}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      {/* <ReactTable
        filterable
        defaultFilterMethod={UtilHelper.filterColumnReactTable}
        defaultPageSize={10}
        noDataText='No records present. Click Add case to create a new case'
        data={props.cases}
        columns={columns}
        loading={loading}
        className="-striped -highlight"
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              handleRowClick(rowInfo.original)
            }
          }
        }}
      /> */}
      <DataGrid
        isLoading={loading}
        gridRef={dataGridRef}
        columnDefs={columnDefs}
        rowData={props.cases}
        gridOptions={{
          quickFilterText: debouncedSearch
        }}
        onRowClicked={(event) => {
          console.log('Row clicked:', event.data);
          // Open edit user model
          handleRowClick(event.data)
        }}
      />
      <CaseDetailsModal isModalOpen={showCaseDetailsModal} setIsModalOpen={setShowCaseDetailsModal} caseDetails={selectedCase} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cases: state.caseReducer.cases,
    userResources: state.authorisation.userResources,
    loggedInUser: state.auth.loggedInUser,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllCases: (organizationId, queryParams) => {
      return dispatch(getAllCasesRequest(organizationId, queryParams)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
    updatePageTitle: (pageTitle, enablePageTitle) => {
      dispatch(setPageTitle(pageTitle, enablePageTitle));
    },
  }
};

const CaseTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseTableComponent);

export default CaseTable;
